import moment from 'moment';
import { create, factureGeneration } from '@/api/facture/index';

export default async function createFactureOrGenerateFromCommande(facture, commandes) {
  let newFacture = null;
  if (!commandes.length) {
    facture.code = null;
    newFacture = (await create(facture)).data.result;
    return newFacture;
  }
  const idLignesEcheancier = [];
  const echeanciers = commandes.map(cmd => cmd.echeanciers).flat();
  echeanciers.forEach((echeancier) => {
    return echeancier.echeancierLignes.forEach((ligne) => {
      if (ligne.factureId === facture.id) idLignesEcheancier.push(ligne.id);
    });
  });
  newFacture = (await factureGeneration({
    listeEcheancierLigneId: idLignesEcheancier,
    dateFacturation: moment().format('YYYY-MM-DD'),
    calculeEnQuantite: true,
    genererFactureZero: facture.montantTtc === 0,
    genererUneSeuleFacture: commandes.length > 1,
  })).data.result;
  return newFacture[0];
}
